import React from "react";
import PropertyResearchMap from "./PropertyResearchMap";
import {
  metricValue,
  statusLabels,
  scopeLabels,
} from "@/lib/evidencePresentation";
import { ArrowUpRight } from "lucide-react";

export default function ResearchOverview({
  report,
  goal = "invest",
  locality,
  selectedLayers,
  metrics = report.evidence.metrics,
}) {
  const priorities =
    goal === "invest"
      ? ["rent", "flood", "planning"]
      : ["flood", "planning", "transport"];
  return (
    <div className="research-overview" id="overview">
      <PropertyResearchMap
        location={report.evidence.location}
        locality={locality}
        selectedLayers={selectedLayers}
      />
      <section className="overview-summary" aria-label="Research overview">
        <span className="eyebrow">The bigger picture</span>
        <h2>Your research overview</h2>
        <p>Start with the evidence. Keep the gaps in view.</p>
        {metrics
          .filter(
            (metric) =>
              priorities.includes(metric.id) &&
              metric.status !== "unavailable",
          )
          .sort((a, b) => priorities.indexOf(a.id) - priorities.indexOf(b.id))
          .map((m) => (
            <a
              className="overview-row"
              key={m.id}
              href={`#metric-${m.id}`}
            >
              <span>
                {m.label}
                <strong className="overview-value">
                  {m.status === "unavailable"
                    ? "Further checks needed"
                    : metricValue(m)}
                </strong>
                <small>
                  {m.status === "unavailable"
                    ? "Evidence unavailable"
                    : statusLabels[m.status] || "Evidence unavailable"}
                </small>
                {m.geography_type && (
                  <small>
                    {scopeLabels[m.geography_type] || m.geography_type}
                    {m.geography_id ? ` · ${m.geography_id}` : ""} ·{" "}
                    {m.observation_period || "Source period not recorded"}
                  </small>
                )}
                {m.id === "flood" && m.status !== "unavailable" && (
                  <small>
                    Partial council overlap evidence. Not intended for due
                    diligence or conveyancing.
                  </small>
                )}
                <small>
                  {m.status === "unavailable"
                    ? "Not assessed · further checks needed"
                    : m.status === "user_provided"
                      ? "Your input · not independently verified"
                      : `${m.source_name || "Available evidence"}${m.status === "stale" ? " · Older evidence" : ""}`}
                </small>
              </span>
              <ArrowUpRight size={18} />
            </a>
          ))}
        <a className="text-link" href="#locality">
          Explore nearby records →
        </a>
      </section>
    </div>
  );
}
